/**
 * Import Features
 */
import { changeStep } from './features/changeStep';
import {modal} from './features/modal';
import { onBoarding } from './features/onBoarding';

/**
 * Import Utils
 */
import {ui} from './utils/ui';

export default () => {

    // Modal Contact Gustave Rideau
    if (ui.gustaveModal) modal(ui.gustaveModal.container, ui.gustaveModal.open, ui.gustaveModal.close);

    // Modal Contact Gift
    if (ui.giftModal) modal(ui.giftModal.container, ui.giftModal.open, ui.giftModal.close);

    // Modal Sponsor
    if (ui.sponsorModal) modal(ui.sponsorModal.container, ui.sponsorModal.open, ui.sponsorModal.close);

    // Modal Create Project
    if (ui.createProjectModal) modal(ui.createProjectModal.container, ui.createProjectModal.open, ui.createProjectModal.close) 
    if (ui.createProjectModal) changeStep(ui.createProjectModal.container, ui.createProjectModal.modalNextStep, ui.createProjectModal.modalFirstStep, ui.createProjectModal.modalSecondStep);

    // Modal Onboarding
    const isOnboardingDone = localStorage.getItem("isOnboardingDone")
    if (ui.onboardingModal && isOnboardingDone === null) {
        modal(ui.onboardingModal.container, ui.onboardingModal.open, ui.onboardingModal.close)
        onBoarding(ui.onboardingModal.modalNextStep, ui.onboardingModal.modalPreviousStep, ui.onboardingModal.modalFirstStep, ui.onboardingModal.modalSecondStep, ui.onboardingModal.modalThirdStep, ui.onboardingModal.onboardingTitle, ui.onboardingModal.btnsContainer, ui.onboardingModal.container)
    }
    
    

    window.onclick = (event: MouseEvent) => {
        if (event.target === ui.gustaveModal.container || event.target === ui.giftModal.container) {
            ui.gustaveModal.container.classList.remove('open');
            ui.giftModal.container.classList.remove('open');
        } else if (event.target === ui.sponsorModal.container) {
            ui.sponsorModal.container.classList.remove('open');
        } else if (event.target === ui.createProjectModal.container) {
            ui.createProjectModal.container.classList.remove('open');
        }
    }
}
